/* eslint-disable jsx-a11y/anchor-is-valid */

// NPM libraries
import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

// Semantic UI Components
import {
  Button,
  Container,
  Dimmer,
  Dropdown,
  Header,
  Loader,
  Message,
} from 'semantic-ui-react';

// Components
import Forbidden from '../Errors/Forbidden';
import ConfettiShower from '../ConfettiShower';

class Raffle extends React.Component {

  constructor() {
    super();

    this.state = {
      winner: null,
      loading: false,
      error: null,
      isConfettiActive: false,
      users: [],
      selectedEvent: '',
    };

    this.handleRaffle = this.handleRaffle.bind(this);
    this.getUsers = this.getUsers.bind(this);
    this.handleEventChange = this.handleEventChange.bind(this);

  }

  async getUsers(jwt) {
    const API_URL = 'https://qt57s58zgj.execute-api.us-east-1.amazonaws.com/dev';
    const response = await axios({
      method: 'get',
      url: `${API_URL}/user`,
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
      validateStatus: status => {
        return status <= 500;
      },
    })
      .catch(error => {
        console.error(error);
        this.props.authStateHandler({ auth: false, admin: null });
      });
    if (response && response.status >= 200 && response.status < 300) {
      return response.data;
    }
  }

  async getWinner(jwt, event) {
    const API_URL = 'https://qt57s58zgj.execute-api.us-east-1.amazonaws.com/dev';
    const url = event ? `${API_URL}/winner?event=${encodeURIComponent(event)}` : `${API_URL}/winner`;
    const response = await axios({
      method: 'get',
      url,
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
      validateStatus: status => {
        return status <= 500;
      },
    })
      .catch(error => {
        console.error(error);
        this.props.authStateHandler({ auth: false, admin: null });
      });
    if (response) {
      if (response.status >= 200 && response.status < 300 && response.data.name) {
        if (this.state.error) this.setState({ error: null });
        this.setState({
          winner: response.data.name,
          isConfettiActive: true,
        });
        setTimeout(() => this.setState({ isConfettiActive: false }), 5000);
      } else {
        this.setState({
          error: (<Message negative header="Ha ocurrido un error" content={response.data.message}/>),
        });
      }
    }
  }

  handleEventChange(e, { value }) {
    this.setState({ selectedEvent: value });
  }

  async handleRaffle() {
    const { selectedEvent } = this.state;
    this.setState({
      loading: true,
    });
    const { auth, admin } = this.props;
    if (auth && admin && admin.jwt) {
      await this.getWinner(admin.jwt, selectedEvent);
      this.setState({
        loading: false,
      });
    }
  }

  async componentDidMount() {
    const { auth, admin } = this.props;
    if (auth && admin && admin.jwt) {
      const response = await this.getUsers(admin.jwt);
      if (response) {
        this.setState({
          users: response.Items,
        });
      }
    }
  }

  content() {
    const { loading, error, winner } = this.state;
    if (loading) {
      return (
        <Dimmer active>
          <Loader>Cargando</Loader>
        </Dimmer>
      );
    } else if (error) {
      return error;
    } else if (winner) {
      return (
        <Header
          style={{
            textTransform: 'capitalize',
          }}
          size="huge"
          content={`¡${winner.trim().toLowerCase()}!`}
        />
      );
    } else {
      return (
        <Message content="¡Todavía no has elegido a un ganador!"/>
      );
    }
  }

  render() {
    const { auth, admin } = this.props;
    const { users, selectedEvent } = this.state;
    
    const eventOptions = [...new Set(users.map(user => user.event).filter(Boolean))]
      .map(event => ({ key: event, value: event, text: event }));

    if (auth && admin && admin.jwt) {
      return (
        <Container
          style={{
            margin: '7.5em 0',
            flex: 1,
            textAlign: 'center',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <h2>Rifa</h2>
          <Dropdown
            placeholder="Selecciona un evento"
            selection
            options={eventOptions}
            value={selectedEvent}
            onChange={this.handleEventChange}
            style={{ marginBottom: '1em' }}
          />
          <h3>El ganador es:</h3>
          {this.state.isConfettiActive && <ConfettiShower />}
          {this.content()}
          <Button 
            onClick={this.handleRaffle}
            disabled={!selectedEvent}
          >
            Elige un ganador
          </Button>
        </Container>
      );
    } else {
      return (
        <Forbidden/>
      );
    }
  }

}

Raffle.propTypes = {
  authStateHandler: PropTypes.func,
  auth: PropTypes.bool,
  admin: PropTypes.object,
};

Raffle.defaultProps = {
  authStateHandler: ({ auth, admin }) => {
    this.props.auth = auth;
    this.props.admin = admin;
  },
  auth: false,
  admin: null,
};

export default Raffle;
